import { useCallback, useEffect, useState } from 'react';
import { UserEarlyAccessResponse } from '../../LandingScreens/Types/EarlyAccessType';
import { getAllEarlyAccessData } from '../../LandingScreens/Service/EarlyAccessService';
import EarlyAccessUsersComponent from '../Components/EarlyAccessUsersComponent';

const FETCH_SIZE = 1000;

function EarlyAccessPage() {
  const [adminData, setAdminData] = useState<UserEarlyAccessResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  const fetchEarlyAccess = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getAllEarlyAccessData(0, FETCH_SIZE);
      if (response.success) {
        setAdminData(response.data.content ?? []);
        setError('');
      } else {
        setError(response.message || 'Failed to load early access users.');
      }
    } catch (err) {
      setError('Failed to load early access users.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchEarlyAccess();
  }, [fetchEarlyAccess]);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 p-8 text-sm font-semibold text-slate-400">
        Loading early access users...
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-slate-950 p-8 text-sm font-semibold text-rose-400">
        {error}
      </div>
    );
  }

  return (
    <EarlyAccessUsersComponent
      data={adminData}
      menuName="Early Access"
      onChanged={fetchEarlyAccess}
    />
  );
}

export default EarlyAccessPage;
